import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WkAuthenticationService } from '../../services/wk-authentication.service';
import { LocalStorage } from '../../shared';

@Component({
  selector: 'wk-logout',
  templateUrl: './wk-logout.component.html',
  styleUrls: ['./wk-logout.component.scss'],
  standalone: false,
})
export class WkLogoutComponent implements OnInit {
  loggedIn: boolean;
  constructor(
    private readonly router: Router,
    private readonly auth: WkAuthenticationService
  ) {}

  ngOnInit() {
    this.loggedIn = this.auth.isLoggedIn();
    this.clearLocalStorage();
  }

  private clearLocalStorage(): void {
    const skipWarning = localStorage.getItem(
      LocalStorage.EXTERNAL_PASTE_SKIP_WARNING
    );
    localStorage.clear();
    if (skipWarning !== null) {
      localStorage.setItem(
        LocalStorage.EXTERNAL_PASTE_SKIP_WARNING,
        skipWarning
      );
    }
  }

  login() {
    this.router.navigate(['login']);
  }

  navigateToDashboard() {
    this.router.navigate(['dashboard']);
  }
}
